// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__Name__2TZ4r{padding-left:0;margin-bottom:16px;display:flex;flex-direction:row;align-items:center;justify-content:space-between}.styles-module__Status__1FI3M{height:24px}.styles-module__Status__1FI3M>*:not(:last-child){margin-right:8px}.styles-module__ExperimentTag__2hj5_{font-size:18px;color:#888;margin-left:18px}", ""]);
// Exports
exports.locals = {
	"Name": "styles-module__Name__2TZ4r",
	"Status": "styles-module__Status__1FI3M",
	"ExperimentTag": "styles-module__ExperimentTag__2hj5_"
};
export default exports;
